import SceneNode from '@ps/views/workbench/board/storyboard/scene-node.vue'
import { Cell, Graph } from '@antv/x6'

export function addScene({ metaData, graph }: { metaData: Cell.Metadata; graph: Graph }) {
  const node = graph.addNode({
    ...metaData,
    attrs: {
      body: {
        // width: 200,
        // height: 200,
        // stroke: 'red'
      }
    },
    component: {
      template: `<scene-node :node-id="data.nodeId"></scene-node>`,
      data() {
        return metaData
      },
      methods: {},
      components: {
        SceneNode
      }
    },
    shape: 'vue-shape'
  })
  return node
}
